export const body =
  'Vårt rostfria sortiment är, om ej annat anges, av elektropolerat syrafast rostfritt stål (SS 304). Gjutgods av syrafast SS 316.'
